import { OlympusClient } from '@/OlympusClient'
import { convertToPathObject } from '@/utils/structure'

const singleBrandActions = {
  brand: {
    update: {
      // not called directly anywhere so not persisting to new store
      assets: async ({ commit }, { brandId, updatedAssets }) => {
        const { id, assets } = await OlympusClient.brandsV0.brand.updateBrand({
          assets: updatedAssets,
          params: {
            brandId,
          },
        })

        commit('UPDATE_BRAND_ASSETS', { id, update: assets })
      },
      domain: async ({ commit }, { brandId, domain }) => {
        commit('SET_BRAND_DOMAIN', { brandId, domain })
      },
      // note: link is not being used anywhere and also `updateLinks` is not a valid endpoint
      // so not being persisted to new store
      link: async ({ commit, getters }, { brandId, update }) => {
        const targetLinks = getters['brand/links/*'](brandId)

        if (targetLinks) {
          const updatedLinks = { ...targetLinks, ...update }

          const { id, links } = await OlympusClient.brandsV0.brand.updateLinks({
            body: updatedLinks,
            params: {
              brandId,
            },
          })

          commit('UPDATE_BRAND_LINKS', { id, update: links })
        }
      },
      // not called directly anywhere so not persisting to new store
      name: async ({ commit }, { brandId, newName }) => {
        const { id, name } = await OlympusClient.brandsV0.brand.updateBrand({
          body: {
            name: newName,
          },
          params: {
            brandId,
          },
        })

        commit('UPDATE_BRAND_NAME', { id, update: name })
      },
      // not called directly anywhere so not persisting to new store
      priceRange: async ({ commit }, { brandId, newPriceRange }) => {
        const { id, priceRange } =
          await OlympusClient.brandsV0.brand.updateBrand({
            body: {
              priceRange: newPriceRange,
            },
            params: {
              brandId,
            },
          })

        commit('UPDATE_BRAND_PRICE_RANGE', { id, update: priceRange })
      },
      // can just call updateBrand action so don't need to persist this endpoint
      sendFormsTo: async ({ commit }, { brandId, newSendFormsTo }) => {
        const { id, sendFormsTo } =
          await OlympusClient.brandsV0.brand.updateBrand({
            body: {
              sendFormsTo: newSendFormsTo,
            },
            params: {
              brandId,
            },
          })

        commit('UPDATE_BRAND_SEND_FORMS_TO', { id, update: sendFormsTo })
      },
    },
  },
}

export default {
  ...convertToPathObject(singleBrandActions),
}
